import 'slick-carousel'

// Ensure slick library has been included
if ( typeof $.fn.slick == 'function' ) {
    // site sliders

    $('.js-gallery').slick({
        centerMode: true,
        slidesToShow: 5,
        infinite: true,
        nextArrow: '<i class="fa fa-angle-right"></i>',
        prevArrow: '<i class="fa fa-angle-left"></i>',
        responsive: [
            {
            breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
            breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })
}
